var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBianjiHongqi2Xian(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.227 9.576l.037-.005 2.138-.274a.685.685 0 00.598-.68V2.18c0-.402-.371-.7-.764-.614l-2.12.466a5.354 5.354 0 01-3.165-.268 6.354 6.354 0 00-3.065-.432l.742.965c.664.008 1.324.14 1.946.393a6.354 6.354 0 003.757.319L13 2.642V8.34l-1.863.24c-.211.026-.422.045-.634.054l.724.942zM4.455 2.41a5.342 5.342 0 00-.227.053L3 2.78V8.2l1.061-.158a8.822 8.822 0 013.837.273c.428.128.865.22 1.307.272l.812 1.056a8.822 8.822 0 01-2.406-.37 7.822 7.822 0 00-3.402-.242L3 9.21v5.29a.5.5 0 01-1 0V2.7c0-.41.277-.768.674-.87l1.114-.285.667.866z",
    fill: "#3F465C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 1l10 13",
    stroke: "#3F465C",
    strokeLinecap: "round"
  })));
}
export default __webpack_public_path__ + "static/bianji_hongqi2_xian.4bdf58a0.svg";
export { SvgBianjiHongqi2Xian as ReactComponent };